import { IconWrapper } from '../runtime';
export default IconWrapper('document-upload-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2 2.64049C2 1.18246 3.18197 0.000488281 4.64 0.000488281L17.0665 0.000488758C17.7666 0.000488758 18.4381 0.278631 18.9332 0.773727L22.2268 4.06725C22.7219 4.56235 23 5.23384 23 5.93401V21.3605C23 22.8185 21.818 24.0005 20.36 24.0005H4.64C3.18197 24.0005 2 22.8185 2 21.3605V2.64049Z",
      "fill": 'url(#' + props.id + '5ff81937' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M17.4961 0.000488281V0.000488281C18.2332 0.000488281 18.9401 0.293237 19.4615 0.814361L22.6807 4.03247C23.2028 4.55436 23.4961 5.2623 23.4961 6.00049V6.00049H18.9961C18.1677 6.00049 17.4961 5.32891 17.4961 4.50049V0.000488281Z",
      "fill": "white",
      "fill-opacity": "0.3"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.2348 8.4545C12.3813 8.30805 12.6187 8.30805 12.7652 8.4545L16.7495 12.4389C16.896 12.5853 16.896 12.8228 16.7495 12.9692L16.2192 13.4995C16.0728 13.646 15.8353 13.646 15.6889 13.4995L13.25 11.0607V17.5C13.25 17.7071 13.0821 17.875 12.875 17.875H12.125C11.9179 17.875 11.75 17.7071 11.75 17.5V11.0607L9.31112 13.4995C9.16467 13.646 8.92724 13.646 8.78079 13.4995L8.25046 12.9692C8.10401 12.8228 8.10401 12.5853 8.25046 12.4389L12.2348 8.4545Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '5ff81937',
      "x1": "4.55391",
      "y1": "1.30055",
      "x2": "26.8934",
      "y2": "14.9599",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});